import {
    type GetEventForAdminResponseType,
    type GetEventForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const getEventForAdmin = async (params: GetEventForAdminRequestType): Promise<GetEventForAdminResponseType> => {
    return await request<GetEventForAdminResponseType>(`/events/getEventForAdmin?eventID=${params.eventID}`, {
        method: "GET"
    });
};

export default getEventForAdmin;
